import React from 'react';
import ApiFetch from "../components/ApiFetch";

export async function isMute(muteUserId,dialog){
    return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/mute/user/"+muteUserId).then((r)=>{
        return r.json().then((json)=>{
            if(json.result){
                console.log("ミュート済みです。",muteUserId)
            } else {
                dialog("エラー",json.errors)
            }
            return json.result
        })
    })
}
export async function getMuteList(userId,page,dialog){
    return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/mute/muteList/"+userId+"/"+page).then((r)=>{
        return r.json().then((json)=>{
            return json
        })
    })
}
export async function getMutedList(userId,page,dialog){
    return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/mute/muteList/"+userId+"/"+page).then((r)=>{
        return r.json().then((json)=>{
            return json
        })
    })
}
export async function mutePost(muteUserId,dialog){
    return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/mute/"+muteUserId,{}).then((r)=>{
        return r.json().then((json)=>{
            if(json.result){
                //console.log("ミュートしました。",muteUserId)
            } else {
                dialog("エラー",json.errors)
            }
            return json.result
        })
    })
}
export async function muteDelete(muteUserId,dialog){
    return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/mute/"+muteUserId,{}).then((r)=>{
        return r.json().then((json)=>{
            if(json.result){
                //console.log("フォロー解除しました。",followUserId)
            } else {
                dialog("エラー",json.errors)
            }
            return json.result
        })
    })
}


